<template>
  <div>
    <b-card
      class="light-style"
      footer-tag="footer"
    >
      <custom-loader v-if="loader"/>
      <b-form v-else>
        <b-form-row class="pt-3">
          <b-form-checkbox class="ml-2" v-model="modalData.visible_on_public_site">
            Visible on Public Site
          </b-form-checkbox>
        </b-form-row>
        <b-form-row class="pt-3">
          <b-form-group class="col" label="Button Text">
            <b-input
              v-model="modalData.registration_button_label"
              autocomplete="off"
              data-lpignore="true"
            />
          </b-form-group>
        </b-form-row>
        <b-form-row class="pt-3">
          <b-form-group class="col" label="Description">
            <ckeditor
              id="WorkshopFormDescription"
              v-model="modalData.description"
            />
          </b-form-group>
        </b-form-row>
        <b-form-row class="pt-3">
          <b-form-group class="col" label="Teaser">
            <ckeditor
              id="WorkshopFormTeaser"
              v-model="modalData.teaser"
            />
          </b-form-group>
        </b-form-row>
        <b-form-row class="pt-3">
          <b-form-group class="col" label="Registrant information">
            <ckeditor
              id="WorkshopFormRegistrantInformation"
              v-model="modalData.registrant_information"
            />
          </b-form-group>
        </b-form-row>
        <b-form-row class="pt-3">
          <b-form-group class="col" label="Image Caption Name">
            <ckeditor
              id="image_caption_name"
              v-model="modalData.image_caption_name"
              :toolbar="customCkEditorItems"
            />
          </b-form-group>
        </b-form-row>
        <div class="custom-card pt-2">
          <label>Image</label>
          <b-card class="light-style">
            <div class="table-responsive">
              <table class="table">
                <tbody>
                  <tr>
                    <td colspan="7">
                      <div class="text-center p-5">
                        <label class="btn btn-default">
                          <input
                            type="file"
                            accept="image/*"
                            id="workshopImage"
                            ref="workshopImage"
                            @change="uploadImage($event)"
                          />
                        </label>
                      </div>
                    </td>
                  </tr>
                  <div v-if="modalData.image_url">
                    <tr class="row">
                      <td class="col-md-3 text-center">
                        <img
                          :src="modalData.image_url"
                          width="100"
                          height="auto"
                          onerror="this.onerror=null;this.src='/img/SLMath/SLMath_default.png';"
                        />
                      </td>
                      <td class="col-md-7 uploaded-image">
                        {{ modalData.image_name }}
                      </td>
                      <td class="col-md-2 uploaded-image">
                        <i
                          v-b-tooltip.hover.left="'Delete Uploaded Image'"
                          class="fas fa-trash cursor-pointer custom-fa-delete-color"
                          ref="uploadImage"
                          @click="removeImage()"
                        ></i>
                      </td>
                    </tr>
                  </div>
                </tbody>
              </table>
            </div>
          </b-card>
        </div>
        <div class="custom-card pt-3">
          <label>Tags/Keywords</label>
          <small class="d-block text-muted">Type a comma or press Enter to create a new tag.</small>
          <multiple-select-tagging-section :edit-list="modalData.tag_edit_list" :options="tagListing" />
        </div>
        <div class="custom-card pt-3">
          <label>Primary Mathematics Subject Classification</label>
          <MultipleSelectAMS
            :edit-list="modalData.primary_ams"
            field="primary_ams"
            placeholder="Search Primary AMS"
          />
        </div>
        <div class="custom-card pt-3">
          <label>Attentance types*</label>
          <div v-for="(input, k) in attendances" :key="k" class="mb-2">
            <div class="d-flex align-items-center">
              <b-form-input
                autocomplete="off"
                data-lpignore="true"
                v-model="input.attendance_type"
                type="text"
              />
              <i
                v-if="attendances.length > 1"
                v-b-tooltip.hover.top="'Remove'"
                class="fas fa-trash cursor-pointer ml-3 custom-fa-delete-color"
                @click="remove(k)"
              ></i>
            </div>
            <b-form-invalid-feedback :state="!$v.attendances.$each[k].attendance_type.$error">
              This field is required
            </b-form-invalid-feedback>
          </div>
          <b-btn size="sm" @click="add">
            <i class="fa fa-plus-square" /> Add
          </b-btn>
        </div>
      </b-form>
      <template #footer>
        <div class="d-flex justify-content-end align-items-center">
          <b-button
            variant="danger"
            :disabled="loader"
            @click="close()"
            class="mr-2"
          >
            <b-spinner v-if="loader" />
            CLOSE
          </b-button>
          <b-button
            variant="success"
            class="submit-btn"
            :disabled="loader"
            type="submit"
            @click="onSubmit($event)"
          >
            <b-spinner v-if="loader" />
            UPDATE
          </b-button>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import CustomLoader from "@/components/CommonPages/CustomLoader.vue"
import MultipleSelectTaggingSection from "@/components/custom/MultipleSelectTaggingSection.vue"
import MultipleSelectAMS from "@/components/custom/MultipleSelectAMS.vue"
import mixin from "@/utils/mixin.js"

export default {
	name: "WorkshopSettingsModalForm",
	props: ["modalData", "tagListing"],
	mixins: [mixin],
	components: { CustomLoader, MultipleSelectTaggingSection, MultipleSelectAMS },
	data() {
		return {
			loader: false,
			file: null,
			attendances: [{ id: "", attendance_type: "" }],
			customCkEditorItems: [{ items: ["Mathjax"] }],
		}
	},
	mounted() {
		this.$root.$on("multipleSelectTaggingChange", (values) => {
			this.modalData.tag_edit_list = values
		})
		this.$root.$on("multipleSelectAmsChange", (values, field) => {
			if (field === "primary_ams") {
				this.modalData.primary_ams = values
			}
		})
		if (this.modalData && this.modalData.attendances && this.modalData.attendances.length > 0) {
			this.attendances = this.modalData.attendances
		}
	},
	methods: {
		addPrimaryAms() {
			this.modalData.primary_ams.push({})
		},
		removePrimaryAms(index) {
			this.modalData.primary_ams.splice(index, 1)
		},
		addTag() {
			this.modalData.tag_edit_list.push({})
		},
		removeTag(index) {
			this.modalData.tag_edit_list.splice(index, 1)
		},
		populateImageField() {
			const dt = new DataTransfer()
			if (!!this.modalData.image_name) {
				const fileName = this.modalData.image_name
				this.file = new File([fileName], fileName)
				dt.items.add(this.file)
				if (this.$refs.workshopImage !== undefined) {
					this.$refs.workshopImage.files = dt.files
				}
			}
		},
		uploadImage(e) {
			var selectedFile = e.target.files[0]
			this.file = selectedFile
			this.modalData.image_name = this.file.name
			this.modalData.image_url = URL.createObjectURL(this.file)
		},
		removeImage() {
			if (confirm("Do you really want to delete?")) {
				if (this.file) {
					this.file = null
					this.modalData.image_name = null
					this.modalData.image_url = null
					if (this.image_name) {
						this.populateImageField()
					} else {
						document.getElementById("workshopImage").value = ""
					}
				} else {
					this.loader = true
					this.$http
						.post(process.env.VUE_APP_API_URL + `/workshops/remove_image`, {
							id: this.modalData.id,
						})
						.then((res) => {
							if (res === undefined) {
								//this.$toasted.global.error("Process has been failed.");
							} else if (res.data.error !== undefined) {
								this.$toasted.global.error(res.data.error)
							} else {
								this.$toasted.global.success("Image Removed Successfully")
								this.modalData.image_url = null
								this.modalData.image_name = null
								document.getElementById("workshopImage").value = ""
							}
							this.loader = false
						})
						.catch((err) => {
							this.loader = false
						})
				}
			}
		},
		onSubmit(event) {
			this.$v.$touch()
			event.preventDefault()
			if (this.$v.$invalid) {
				this.$toasted.global.error("Please fill out the required fields.")
			} else {
				this.loader = true
				const formData = new FormData()
				formData.append("visible", this.modalData.visible_on_public_site)
				formData.append(
					"registration_button_label",
					this.checkNullAndEmptyValues(this.modalData.registration_button_label)
						? this.modalData.registration_button_label
						: "",
				)
				formData.append("teaser", this.modalData.teaser)
				formData.append("description", this.modalData.description)
				formData.append("registrant_information", this.modalData.registrant_information)
				formData.append("caption_name", this.modalData.image_caption_name)
				if (this.file) {
					formData.append("files", this.file)
				}
				if (this.modalData.tag_edit_list.length === 0) {
					formData.append("tag_list", [])
				} else {
					this.modalData.tag_edit_list.forEach((res) => {
						for (var key in res) {
							formData.append(`tag_list[][${key}]`, res[key])
						}
					})
				}
				this.modalData.primary_ams.forEach((res) => {
					for (var key in res) {
						formData.append(`primary_msc[][${key}]`, res[key])
					}
				})
				this.attendances.forEach((attentance) => {
					for (var key in attentance) {
						formData.append(`attendances[][${key}]`, attentance[key])
					}
				})
				this.$http.patch(process.env.VUE_APP_API_URL + `/workshops/${this.modalData.id}`, formData).then((res) => {
					if (res === undefined) {
						//this.$toasted.global.error('Process has been failed.')
					} else if (res.data.error !== undefined) {
						this.$toasted.global.error(res.data.error)
					} else {
						this.$toasted.global.success("Updated Successfully")
						this.loader = false
						this.$emit("updateWorkshopData", false)
					}
				})
			}
		},
		close() {
			this.$emit("updateWorkshopData", true)
		},
		add() {
			this.attendances.push({ id: "", attendance_type: "" })
		},
		remove(index) {
			this.attendances.splice(index, 1)
		},
	},
	validations: {
		attendances: {
			$each: {
				attendance_type: {
					required,
				},
			},
		},
	},
}
</script>
